export const isValidZurichVBFormat = (value) => typeof value === 'string' && /^(\d{9}|\d{7})\*(\d|x|X)$/.test(value);
export const isExactlyNineOrElevenCharacters = (value) => value ? value.length === 9 || value.length === 11 : true;
/**
 * `validateIBANCountryCode` is used to check if the country code
 * of the BIC matches the country code of the IBAN.
 *
 * The first two characters of the IBAN, which are the IBAN's
 * country code, are checked against the fourth and fifth
 * characters of the BIC, which contain a two-letter country
 * code.
 *
 * @param value
 * @param options
 * @returns boolean
 */
export function validateIBANCountryCode(value, { options }) {
    if (!value) {
        return false;
    }
    const iban = options?.context?.iban;
    const ibanCountryCode = iban.slice(0, 2);
    const bicCountryCode = value?.slice(4, 6);
    return ibanCountryCode.toLowerCase() === bicCountryCode?.toLowerCase();
}
